//import ViewTodoWordPrintPopup from "@/pages/comp/plan/todo/popup/view_todo_word_print";
import ViewTodoWordPrintArea from "@/pages/comp/plan/todo/common/view_todo_word_print";

function ViewTodoWordPrintPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    todo_pri_val_arr: [],
    print_mode: "",//box,4line
    word_loop_cnt: "5",//5,10
    ...props
  };
  return (
    <div>
      <ViewTodoWordPrintArea
        {...myProps}
      ></ViewTodoWordPrintArea>
    </div>
  );
}

export default ViewTodoWordPrintPopup;
